import { httpClient } from '@ahm/api-wrappers-core';
import { apiRoutes } from '@/api/api-routes';

export type FavoriteDriver = {
  _id: string;
  name: string;
};

export const getListFavoriteDriversFn = async () => {
  const response = await httpClient.get<FavoriteDriver[]>(
    apiRoutes.user.listFavoriteDrivers
  );
  return response.data;
};
